<!-- <div class="panel panel-default table-funel">
  <a class="button-close" (click)="closeDialog()">
    <i class="material-icons fill-nightfall">
      close
    </i>
  </a>
  <ngb-tabset #tabs>
    <ngb-tab id="funnel_opportunity">
      <ng-template ngbTabContent> -->
<np-table-funnel-opportunity [type]="type"></np-table-funnel-opportunity>
<!-- </ng-template>
    </ngb-tab>
  </ngb-tabset>
</div> -->